import { Injectable } from '@angular/core';
import { BrandingConfigurationService, brandValues } from '@ptl/brand';

@Injectable({
  providedIn: 'root'
})
export class BrandAwareService {
  brandValues = brandValues;

  constructor(
    private brandService: BrandingConfigurationService
  ) { }

  goToBrandedUrl(href) {
    const curBrand = this.brandService.getCurrentBrand();
    let domain = window.location.host;

    if (curBrand) {
      domain = curBrand.domain;
    }

    const brandedHref = href.replace('brandme/', domain + '/');

    window.open(brandedHref, '_blank');
  }

}
